const PERSONAL_SETTINGS_SECTIONS = new Set(["preferences", "notifications"]);

const ADMIN_SETTINGS_SECTIONS = new Set([
  "organization",
  "team",
  "ministries",
  "locations",
  "permissions",
  "audit",
  "import",
  "option-lists",
  "widgets",
  "custom-fields",
  "tags",
  "modules",
  "workflows",
  "today",
  "billing",
  "security",
  "voice",
  "kids-checkin",
]);

const ORG_ADMIN_ONLY_SECTIONS = new Set(["voice"]);

/** A `/settings/:section` that SettingsPage renders, whoever may open it. */
export function isSettingsSection(section: string): boolean {
  return PERSONAL_SETTINGS_SECTIONS.has(section) || ADMIN_SETTINGS_SECTIONS.has(section);
}

/** A section that configures the signed-in person, not the organization (every member may open it). */
export function isPersonalSettingsSection(section: string): boolean {
  return PERSONAL_SETTINGS_SECTIONS.has(section);
}

export function canAccessSettingsSection(
  section: string,
  options: { isAdmin: boolean; isOrgAdmin: boolean },
): boolean {
  if (PERSONAL_SETTINGS_SECTIONS.has(section)) {
    return true;
  }

  if (!ADMIN_SETTINGS_SECTIONS.has(section) || !options.isAdmin) {
    return false;
  }

  return !ORG_ADMIN_ONLY_SECTIONS.has(section) || options.isOrgAdmin;
}

export function getDefaultSettingsSection(options: {
  isAdmin: boolean;
}): string {
  return options.isAdmin ? "organization" : "preferences";
}
